// Adapts a brand's semantic color map into Vuetify palette + CSS custom properties.

// Maps each semantic color to its CSS variable, legacy CSS aliases, and Vuetify palette keys.
const COLOR_SPEC = {
  primary: { cssVar: "--primary", cssAliases: ["--blue-01"], vuetify: ["blue"] },
  primaryDark: {
    cssVar: "--primary-dark",
    cssAliases: ["--darkBlue"],
    vuetify: ["primary", "darkBlue", "textcolor"],
  },
  primarySoft: { cssVar: "--primary-soft", cssAliases: ["--blue-02"], vuetify: ["blue-04"] },
  secondary: { cssVar: "--secondary", cssAliases: [], vuetify: ["secondary"] },
  secondarySoft: { cssVar: "--secondary-soft", cssAliases: [], vuetify: ["secondaryAccent"] },
  accent: { cssVar: "--accent", cssAliases: ["--light-red"], vuetify: ["accent", "light-red"] },
  onAccent: { cssVar: "--on-accent", cssAliases: ["--brown"], vuetify: ["brown"] },
  surface: { cssVar: "--surface", cssAliases: [], vuetify: ["surface"] },
  surfaceAccent: { cssVar: "--surface-accent", cssAliases: [], vuetify: ["sufaceAccent"] },
};

const COLOR_KEYS = Object.keys(COLOR_SPEC);

// Non-brand palette keys, kept fixed across all brands.
const BASE_VUETIFY = {
  black: "#212121",
  "blue-05": "#E1E8F5",
  success: "#06C270",
  "success-01": "#E1F8EE",
  error: "#E6393E",
  answered: "#009051",
  skipped: "#F6E866",
  bookmarked: "#E868E3",
  textAccent: "#FD786E",
  textAccentBackground: "#FFEED9",
};

// adapts semantic brand colors to application consumable css variables/ vuetify color pallete
export function deriveTheme(colors = {}) {
  const cssVars = {};
  const vuetify = { ...BASE_VUETIFY };

  Object.entries(COLOR_SPEC).forEach(([name, spec]) => {
    const value = colors[name];
    if (value == null) return;
    cssVars[spec.cssVar] = value;
    spec.cssAliases.forEach((alias) => {
      cssVars[alias] = value;
    });
    spec.vuetify.forEach((key) => {
      vuetify[key] = value;
    });
  });

  return { cssVars, vuetify };
}

export function extractBrandColors(brandingConfig) {
  const colors = brandingConfig && brandingConfig.colors;
  if (!colors) return {};

  const result = {};
  Object.entries(colors).forEach(([key, value]) => {
    if (!COLOR_KEYS.includes(key)) {
      console.warn(
        `[branding] Ignoring unknown color key "${key}" (expected one of: ${COLOR_KEYS.join(", ")})`
      );
      return;
    }
    if (value != null) result[key] = value;
  });
  return result;
}
